module.exports = __webpack_public_path__ + "img/img-error.c4250d03.png";